import React from 'react'
import { Display, Button, Message, Form, DraggableCards, DraggableCard, DroppableCards, DroppableCard } from './shared'
import withDragAndDrop from './withDragAndDrop'
import styles from './DragAndDrop.module.css'

class DragAndDrop extends React.Component {
  static defaultProps = {
    data: null,
    onChange: (data) => {},
    onSubmit: null,
    droppables: [],
    draggables: [],
    feedback: null,
  }

  get submitted() {
    return this.props.submitted || this.props.dnd.state.submitted
  }

  render() {
    return (
      <div className={`dragndrop-el ${styles.base}`}>
        <Form className="dragndrop-scene-el" disabled={this.submitted}>
          <DroppableCards>
            {this.props.dnd.state.dropList.map(item => (
              <DroppableCard
                key={item.id}
                data={item}
                list={this.props.dnd.state[`list-${item.id}`]}
                submitted={this.submitted}
                draggable={{
                  submitted: this.submitted,
                  onDrop: this.props.dnd.handleDrop,
                }} />
            ))}
          </DroppableCards>
        </Form>

        <Display if={!(this.props.inside && this.submitted)}>
          <div className={`dragndrop-footer-el ${styles.footer} ${this.props.columns ? styles.columns : ''}`}>
            {this.props.feedback && this.props.feedback.info &&
            <div className="dragndrop-footer-info">
              <Message vertical={!this.props.columns} button={this.props.inside ? false : {
                icon: 'arrow-right',
                label: this.props.saveButtonLabel || "Controleer",
                onClick: this.props.dnd.handleSubmit,
                disabled: !this.props.dnd.isFilled || this.submitted,
              }}>
                <p>{this.props.feedback.info}</p>
              </Message>
            </div>
            }

            <div className="dragndrop-footer-cards">
              <Display if={this.submitted}>
                {this.props.feedback &&
                <>
                  <Display if={this.props.dnd.state.passed && this.props.feedback.correct}>
                    <Message success>
                      <p>{this.props.feedback.correct}</p>
                    </Message>
                  </Display>

                  <Display if={!this.props.dnd.state.passed && this.props.feedback.wrong}>
                    <Message error>
                      <p>{this.props.feedback.wrong}</p>
                    </Message>

                    <Button
                        icon="reload"
                        label="Probeer nogmaals"
                        onClick={this.props.dnd.handleRestart}/>
                  </Display>
                </>
                }
              </Display>

              <Display if={this.props.dnd.draggables.length > 0}>
                <DraggableCards>
                  {this.props.dnd.draggables.map(item => (
                      <DraggableCard
                          key={item.id}
                          data={item}
                          onDragStart={this.props.dnd.handleDragStart}
                          onDragEnd={this.props.dnd.handleDragEnd}
                          onDrop={this.props.dnd.handleDrop}
                      >
                        {item.active || item.dropped ? item.labelActive : item.label}
                      </DraggableCard>
                  ))}
                </DraggableCards>
              </Display>
            </div>
          </div>
        </Display>
      </div>
    )
  }
}

export default withDragAndDrop(DragAndDrop)
